import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ReactComponent as WhiteStarIcon } from 'assets/icons/white-star.svg';
import { ReactComponent as YellowStarIcon } from 'assets/icons/yellow-star.svg';
import useDashboardContext from 'contexts/dashboard.context';
import { handleApiError } from 'utils/functions';
import { OrderType } from 'models/order.model';

type RateServiceModalProps = {
  show: boolean;
  onClose: () => void;
  order: OrderType;
};

const RateServiceModal: FC<RateServiceModalProps> = ({ show, onClose, order }) => {
  const [selectedRate, setSelectedRate] = useState<number | null>(null);
  const handleRate = (rate: number) => {
    setSelectedRate(rate === selectedRate ? null : rate);
  };
  const { activeCompany } = useDashboardContext();

  const [optionalNote, setOptionalNote] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOptionalNote('');
    onClose();
  };
  const ratingService = async () => {
    const data = {
      order_id: order.id,
      brand: {
        id: activeCompany.user_id,
        comment: optionalNote,
        rate: selectedRate
      }
    };

    try {
      setLoading(true);
      const res = await apiService.post('order/brand/review', {
        data,
        baseURL: process.env.REACT_APP_CORE_API_URL
      });
      if (res.data) {
        toast(<ToastMessage type='success' message='we appreciate your feedback' />);
        setSelectedRate(null);
        setOptionalNote('');
        onClose();
      } else {
        toast(<ToastMessage type='error' message='Operation Failed' />);
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='Rate service'
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <div className='flex w-full justify-center'>
          {[1, 2, 3, 4, 5].map((rate) => (
            <span
              key={rate}
              onClick={() => handleRate(rate)}
              className='h-[30px] w-[30px] mr-1 cursor-pointer'>
              {rate <= (selectedRate || 0) ? <YellowStarIcon /> : <WhiteStarIcon />}
            </span>
          ))}
        </div>
        <div>
          <div className='text-sm font-medium flex gap-1 mt-5 mb-1'>
            <p className='text-[#2E3031]'>Tell us about your experience</p>
          </div>
          <LocalTextArea
            placeholder='What do you like about FoodCourt Business'
            className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[135px]'
            value={optionalNote}
            onChange={(e) => setOptionalNote(e.target.value)}
          />
        </div>
        <div className='mt-5 flex justify-end'>
          <Button
            color='primary'
            variant='block'
            className='w-[139px] h-[41px]'
            loading={loading}
            disabled={!selectedRate}
            onClick={ratingService}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default RateServiceModal;
